import React from 'react';

const License: React.FC = () => {
  return (
    <div className="bg-dark-blue text-gray-300 p-8 h-full w-[100em] pb-10">
      <h1 className="text-3xl text-center mb-4">Software License Agreement for Deck Hopper</h1>
      <hr className="border-t border-gray-500 my-4 mx-auto w-3/4"/>

      <h5 className="text-xl mb-2">1. Grant of License</h5>
      <p className="mb-4">
        Christina Kral Inc. ("We", "Us") hereby grants you ("Licensee") a non-exclusive, non-transferable, revocable license to use the software "Deck Hopper" ("Software") on any device that you own or control. You are permitted to access and use the Software over a network, provided such use complies with the terms of this license.
      </p>

      <h5 className="text-xl mb-2">2. Restrictions</h5>
      <p className="mb-4">
        You may not:
        <ul className="list-disc list-inside ml-4">
          <li>Distribute, rent, lease, lend, sell, sublicense, or otherwise transfer the Software to any third party.</li>
          <li>Modify, reverse engineer, decompile, or disassemble the Software, except as expressly permitted by applicable law.</li>
          <li>Use the Software for any illegal or unauthorized purpose.</li>
        </ul>
      </p>

      <h5 className="text-xl mb-2">3. Third-Party Components</h5>
      <p className="mb-4">
        This Software utilizes various third-party libraries and components that are distributed under their own respective software licenses. Your use of these components is subject to their respective licenses.
      </p>

      <h5 className="text-xl mb-2">4. No Warranty</h5>
      <p className="mb-4">
        The Software is provided "as is", without warranty of any kind, express or implied, including but not limited to the warranties of merchantability, fitness for a particular purpose, and non-infringement. In no event shall the authors or copyright holders be liable for any claim,
        damages, or other liability arising from your use of the Software.
      </p>

      <h5 className="text-xl mb-2">5. No Obligation to Maintain</h5>
      <p className="mb-4">
        You acknowledge that we have no obligation to furnish any maintenance and support services with respect to the Software or to make any updates or bug fixes available for the Software.
      </p>

      <h5 className="text-xl mb-2">6. Termination</h5>
      <p className="mb-4">
        This license is effective until terminated. Your rights under this license will terminate automatically without notice if you fail to comply with any terms of this license. Upon termination, you must cease all use of the Software and destroy all copies in your possession.
      </p>

      <h5 className="text-xl mb-2">7. Consent to Use of Data</h5>
      <p className="mb-4">
        By using the Software, you agree to our <a href="https://christinak.ca/deckhopper/privacy-policy">Privacy Policy</a> and acknowledge that the Software may collect and store personal data as outlined in our Privacy Policy.
      </p>
    </div>
  );
};

export default License;
